<script>
import Layout from '@/layouts/main.vue';
import PageHeader from '@/components/page-header';
// Dashboard de contatos oculto por hora (a pedido) — não usamos por enquanto.
// Para reexibir: descomente o import/registro, a <BTab> no template e volte
// a numeração das abas (Dashboard=0, Contatos=1, Importação=2).
// import ContatoDashboard from '@/components/crm/contato/ContatoDashboard.vue';
import ContatoGrid from '@/components/crm/contato/ContatoGrid.vue';
import ImportacaoContatos from '@/views/app/contato/importacao.vue';

const STORAGE_KEY_TAB = 'crm-contato-tab-ativa';
// Abas visíveis atualmente: 0 = Contatos, 1 = Importação.
const MAX_TAB = 1;

export default {
  name: 'ContatoIndex',
  components: { Layout, PageHeader, ContatoGrid, ImportacaoContatos },
  data() {
    return {
      abaAtiva: this.carregarAbaLocal(),
    };
  },
  methods: {
    carregarAbaLocal() {
      try {
        const tab = Number(window.localStorage.getItem(STORAGE_KEY_TAB));
        if (Number.isInteger(tab) && tab >= 0 && tab <= MAX_TAB) return tab;
      } catch (_error) {
        return 0;
      }
      return 0;
    },
    salvarAbaLocal(tabIndex) {
      if (!Number.isInteger(tabIndex) || tabIndex < 0 || tabIndex > MAX_TAB) return;
      window.localStorage.setItem(STORAGE_KEY_TAB, String(tabIndex));
    },
    onAbaAlterada(tabIndex) {
      this.abaAtiva = tabIndex;
      this.salvarAbaLocal(tabIndex);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader title="Contatos" pageTitle="Contatos" />

    <BCard no-body>
      <div class="card-header border-0">
        <BTabs
          v-model="abaAtiva"
          nav-class="nav-tabs-custom rounded card-header-tabs border-bottom-0"
          content-class="p-0 mt-4"
          @update:modelValue="onAbaAlterada"
        >
          <!-- Aba "Dashboard" oculta por hora (a pedido). Para reexibir,
               reponha esta BTab como índice 0 e renumere as demais (+1). -->
          <BTab>
            <template #title>
              <i class="ri-list-check me-1 align-bottom"></i> Contatos
            </template>
            <ContatoGrid v-if="abaAtiva === 0" />
          </BTab>

          <BTab>
            <template #title>
              <i class="ri-upload-2-line me-1 align-bottom"></i> Importação
            </template>
            <div v-if="abaAtiva === 1" class="card-body">
              <ImportacaoContatos :embutido="true" />
            </div>
          </BTab>
        </BTabs>
      </div>
    </BCard>
  </Layout>
</template>

<style scoped>
</style>
